<template>
    <component :href="`${activeType.type}${info.title}`"
               :class="['contact-title-container', `${color}-color`, {
                 'is-active-arr-content': info?.arrTitle
               }]"
               :is="activeType.type === 'text' ? 'div' : 'a'">
      <div class="icon-container">
        <img :src="getUrl(`${activeType.icon}-${color}`)" alt="icon">
      </div>
      <main-title class="main-title-container"
                  :weight="'medium'"
                  v-if="info.title">
        {{ info.title }}
      </main-title>
      <div class="arr-container" v-else>
        <div class="arr-content"
             v-for="(item, index) in info.arrTitle"
             :key="index">
          <big-paragraph
              :font-family="'Eurostile'"
              :weight="'medium'" class="mini-title-container">
            {{ item.title }}
          </big-paragraph>
          <main-title
              :weight="'medium'" class="main-title-container" >
            {{ item.text }}
          </main-title>
        </div>
      </div>
    </component>
</template>

<script>
import MainTitle from "@/components/shared/text/MainTitle.vue";
import BigParagraph from "@/components/shared/text/BigParagraph.vue";

export default {
  name: "ContactTitle",
  components: {BigParagraph, MainTitle},
  props: {
    color: {
      type: String,
      default: 'default'
    },
    info: {
      type: Object,
      default: () => {
        return {
          id: 0,
          title: '+00 000 000 00 00',
          type: 'phone'
        }
      }
    }
  },
  methods: {
    getUrl(picture) {
      return require(`@/assets/contacts/${ picture }.svg`)
    },
  },
  computed: {
    activeType() {
      switch (this.info.type) {
        case 'phone':
          return {
            icon: '1',
            type: 'tel:'
          }
        case 'mail':
          return {
            icon: '2',
            type: 'mailto:'
          }
        case 'location':
          return {
            icon: '3',
            type: 'text'
          }
        case 'time':
          return {
            icon: '4',
            type: 'text'
          }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .contact-title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    &.is-active-arr-content {
      align-items: flex-start;
    }

    .arr-container {
      display: flex;
      flex-direction: column;

      .arr-content {
        display: flex;
        flex-direction: column;
      }
    }

    .text-content {
      white-space: pre-wrap;
    }
    .icon-container {
      width: 0;
      & img {
        width: 100%;
        height: 100%;
      }
    }
    &.default-color {
      .text-content {
        color: var(--color-purple-grey)
      }
    }
  }



  @media (max-width: 3024px){

    .contact-title-container {
      column-gap: 48px;

      .arr-container {
        row-gap: 40px;
        .arr-content {
          row-gap: 16px;
        }
      }
      .icon-container {
        min-width: 40px;
        height: 40px;
      }
    }
  }


  @media (max-width: 1920px) {

    .contact-title-container {
      column-gap: 24px;
      .arr-container {
        row-gap: 32px;
        .arr-content {
          row-gap: 12px;
        }
      }
      .icon-container {
        min-width: 32px;
        height: 32px;
      }
    }
  }


  @media (max-width: 1600px) {

    .contact-title-container {
      column-gap: 16px;
      .icon-container {
        min-width: 20px;
        height: 20px;
      }


      .mini-title-container {
        font-size: 12px;
      }

      .main-title-container {
        font-size: 14px;
      }
    }
  }
  @media (max-height: 800px) {
    .contact-title-container {
      column-gap: 16px;
      .icon-container {
        min-width: 16px;
        height: 16px;
      }


      .mini-title-container {
        font-size: 10px;
      }

      .main-title-container {
        font-size: 12px;
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .contact-title-container {
      column-gap: 16px;
      .icon-container {
        min-width: 20px;
        height: 20px;
      }


      .mini-title-container {
        font-size: 12px;
      }

      .main-title-container {
        font-size: 14px;
      }
    }
  }

  @media (max-width: 1133px) {
    .contact-title-container {
      column-gap: 16px;
      .icon-container {
        min-width: 16px;
        height: 16px;
      }

      .mini-title-container {
        font-size: 10px;
      }

      .main-title-container {
        font-size: 12px;
      }
    }
  }

  @media (max-width: 769px) {
    .contact-title-container {
      column-gap: 16px;
      .arr-container {
        row-gap: 16px;
        .arr-content {
          row-gap: 10px;
        }
      }
      .main-title-container {
        font-size: 14px;
      }
      .text-content {
        white-space: normal;
      }
    }
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //plus
  }

  @media (min-height: 600px) and (max-height: 630px){

    //8 plus
  }

  @media (max-width: 375px) {
    //se new
  }

  @media (max-width: 375px) and (min-height: 630px) {
    //x
  }


  @media (max-width: 320px) {
    //se old
  }

  @media (min-width: 3025px) {

    .contact-title-container {
      column-gap: 48px;

      .arr-container {
        row-gap: 40px;

        .arr-content {
          row-gap: 16px;
        }
      }
      .icon-container {
        min-width: 48px;
        height: 48px;
      }
    }
  }

</style>